/**
 * W3C Clear Key UUID.
 *
 *
 * @beta
 */
export const W3C_CLEAR_KEY_UUID = '1077efec-c0b2-4d02-ace3-3c1e52e2fb4b'
